import { render, staticRenderFns } from "./VProjectMomParticipantsForm.vue?vue&type=template&id=744b1068&"
import script from "./VProjectMomParticipantsForm.vue?vue&type=script&lang=js&"
export * from "./VProjectMomParticipantsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports